import { useMutation, useQueryClient } from '@tanstack/react-query';

import { IUpdateGlobalNotification } from '@/interfaces/entities/global-notification';
import { globalNotificationService } from '@/services/global_notification.service';

const useUpdateGlobalNotificaiton = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ([notificationId, notification]: [
			number,
			IUpdateGlobalNotification,
		]) =>
			await globalNotificationService.editGlobalNotifications(
				notificationId,
				notification,
			),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['global-notification'] });
		},

		onError: () => {
			throw new Error('Error editing global notification');
		},
	});
};

export default useUpdateGlobalNotificaiton;
